import styled from 'styled-components'

export const MarginalContent = styled.div`
	h3 {
		margin: 0;
	}
`
